import { getFullName, Name } from "@/utils/names";

export function formatPatientName(value?: Name) {
  if (value) {
    return getFullName(value);
  }
}
